import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import FilterTag from '../common/FilterTag';
import ProjectSummary from '../common/ProjectSummary';
import LocationAutocomplete from '../common/LocationAutocomplete';
import ProjectInvitationCustomTextbox from './ProjectInvitationCustomTextbox';
import { sanitizeResponsibilityHtml, responsibilitiesToListElements, sanitizeOnChangeValue, listElementsToArray } from '../../responsibilitiesUtils';
import ContentEditableComponent from '../common/ContentEditableComponent';
import SearchIcon from '../../../assets/images/search-icon.svg';
import { analyticsTrack } from '../../analyticsUtils';
import { postRequest, getRequest } from '../../requestUtils';
import { ABOUT_TEXT_SUGGESTION } from '../../constants';
var boldIf = function boldIf(str, cond) {
  return cond ? /*#__PURE__*/React.createElement("strong", null, str) : str;
};
var firstName = function firstName(consultant) {
  return consultant.name ? consultant.name.split(' ')[0] : consultant.email;
};
var numericKeyFilter = function numericKeyFilter(e) {
  var re = /[0-9]/;
  if (e.keyCode === 8 || e.keyCode === 46 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40) {
    return;
  }
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};
var getErrorMessages = function getErrorMessages(project) {
  var errorMessages = [];
  var required = {
    name: 'Project name',
    description: 'Description',
    work_location: 'Work location',
    duration_range: 'Length of engagement',
    avg_time_required_range: 'Average hours',
    budget_minimum: 'Min hourly rate',
    budget_maximum: 'Max hourly rate'
  };
  var isBlankRequiredValue = function isBlankRequiredValue(val) {
    return val === undefined || val === null || typeof val === 'string' && val.trim().length === 0;
  };
  Object.entries(required).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      label = _ref2[1];
    var val = project[key];
    if (isBlankRequiredValue(val)) {
      errorMessages.push(label);
    }
  });
  var workLocation = project.work_location;
  if (!workLocation) {
    errorMessages.push('Work Location');
  }
  if (['hybrid', 'office'].includes(workLocation)) {
    if (!project.office_location && !project.days_in_office && !project.office_location_required) {
      errorMessages.push('Office location');
    }
  }

  // Responsibilities: require sufficient content
  if (project.responsibility_areas_attributes && project.responsibility_areas_attributes.length < 100) {
    errorMessages.push('Responsibilities');
  }

  // Ideal candidate: require at least one non-empty bullet
  var idealRaw = project.ideal_candidate_description;
  var idealItems = listElementsToArray(idealRaw);
  var idealHasContent = Array.isArray(idealItems) && idealItems.some(function (t) {
    return String(t).trim().length > 0;
  });
  if (!idealHasContent) {
    errorMessages.push('Ideal candidate');
  }
  return errorMessages;
};
var processRA = function processRA(project, raInput) {
  if (project[raInput]) {
    return responsibilitiesToListElements(project[raInput]);
  }
  return '<li></li>';
};
var initialProjectName = function initialProjectName(filters) {
  if (!filters.area_of_expertises) return null;
  var name = "".concat(filters.area_of_expertises[0], " Consultant");
  if (filters.therapeutic_areas || filters.therapies) {
    var tags = [].concat(_toConsumableArray(filters.therapeutic_areas || []), _toConsumableArray(filters.therapies || [])).join(', ');
    name = "".concat(name, " for ").concat(tags);
  }
  return name;
};
var SearchProjectCreation = /*#__PURE__*/function (_Component) {
  function SearchProjectCreation(props) {
    var _this;
    _classCallCheck(this, SearchProjectCreation);
    _this = _callSuper(this, SearchProjectCreation, [props]);
    _defineProperty(_this, "handleNextFromPage1", function () {
      _this.setPage(2);
    });
    _defineProperty(_this, "createDraftProject", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var csrfToken, project, params, resp, data, updated;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            csrfToken = _this.props.csrfToken;
            project = _this.state.project;
            params = {
              project: {
                name: project.name,
                description: project.description,
                ideal_candidate_description: project.ideal_candidate_description,
                responsibility_areas_attributes: sanitizeResponsibilityHtml(project.responsibility_areas_attributes)
              }
            };
            _context.prev = 3;
            _context.next = 6;
            return postRequest('/projects', params, csrfToken);
          case 6:
            resp = _context.sent;
            data = resp && resp.data ? resp.data : {};
            updated = _objectSpread(_objectSpread({}, project), {}, {
              resource_id: data.resource_id
            });
            _this.setState({
              project: updated
            });
            _context.next = 14;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 12]]);
    })));
    _defineProperty(_this, "openMustHaveModal", function () {
      _this.setState({
        showQualModal: false,
        showMustHaveModal: true
      });
    });
    _defineProperty(_this, "closeQualModal", function () {
      return _this.setState({
        showQualModal: false
      });
    });
    _defineProperty(_this, "closeMustHaveModal", function () {
      return _this.setState({
        showMustHaveModal: false
      });
    });
    var initialProject = props.project || {};
    _this.state = {
      currentPage: props.project ? 3 : 1,
      project: _objectSpread(_objectSpread({}, initialProject), {}, {
        name: initialProject.name || initialProjectName(props.filters),
        description: initialProject.description || ABOUT_TEXT_SUGGESTION,
        higher_level_role_names: props.filters.higher_level_roles,
        area_of_expertise_names: props.filters.area_of_expertises,
        therapeutic_area_names: props.filters.therapeutic_areas,
        disease_code_names: props.filters.diseases,
        therapy_names: props.filters.therapies,
        development_phase_names: props.filters.development_phases,
        degree_names: props.filters.degrees,
        skill_names: props.filters.skills,
        level_names: props.filters.levels,
        responsibility_areas_attributes: processRA(initialProject, 'responsibility_areas_attributes'),
        ideal_candidate_description: processRA(initialProject, 'ideal_candidate_description'),
        rate_negotiable: initialProject.rate_negotiable !== undefined ? initialProject.rate_negotiable : false,
        duration_unit: initialProject.duration_unit || 'months',
        avg_time_required_unit: initialProject.avg_time_required_unit || 'week'
      }),
      suggestionShow: !initialProject.description,
      errorMessages: getErrorMessages(initialProject),
      customMessage: '',
      suggestedOpen: false,
      suggestedLoading: false,
      suggestedHeadline: null,
      suggestedTags: {},
      vocabulary: {},
      showQualModal: false,
      showMustHaveModal: false,
      reviewTags: [],
      // Local (no-project) selections for qualifications & must-haves
      localExpertiseTags: null,
      localNotApplicable: [],
      localPriorityExpertiseTags: null,
      localNonPriorityExpertiseTags: null,
      localPicklists: null
    };
    _this.setPage = _this.setPage.bind(_this);
    _this.handleNestedAttributeChange = _this.handleNestedAttributeChange.bind(_this);
    _this.handleSaveProjectAndInvite = _this.handleSaveProjectAndInvite.bind(_this);
    _this.afterCreateProjectRequest = _this.afterCreateProjectRequest.bind(_this);
    _this.afterCreateOpenMarketplaceInvite = _this.afterCreateOpenMarketplaceInvite.bind(_this);
    _this.handleUpdateCustomMessage = _this.handleUpdateCustomMessage.bind(_this);
    _this.handleListChange = _this.handleListChange.bind(_this);

    // Suggested tags
    _this.fetchSuggestedTags = _this.fetchSuggestedTags.bind(_this);
    _this.toggleSuggestedOpen = _this.toggleSuggestedOpen.bind(_this);
    _this.toggleTagSelection = _this.toggleTagSelection.bind(_this);
    _this.addTagFromDropdown = _this.addTagFromDropdown.bind(_this);
    return _this;
  }
  _inherits(SearchProjectCreation, _Component);
  return _createClass(SearchProjectCreation, [{
    key: "setPage",
    value: function setPage(page) {
      var project = this.state.project;
      var errorMessages = getErrorMessages(project);
      this.setState({
        errorMessages: errorMessages,
        currentPage: page
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(value, key) {
      var project = this.state.project;
      var updatedProject;
      if (key === 'travel_time') {
        updatedProject = _objectSpread(_objectSpread({}, project), {}, _defineProperty(_defineProperty({}, key, value), "days_of_travel", null));
      } else if (key === 'days_of_travel') {
        updatedProject = _objectSpread(_objectSpread({}, project), {}, _defineProperty(_defineProperty({}, key, parseInt(value, 10)), "travel_time", null));
      } else if (key === 'travel_location') {
        updatedProject = _objectSpread(_objectSpread({}, project), {}, {
          project_travel_locations_attributes: [{
            description: value
          }],
          travel_time: 'travel'
        });
      } else {
        updatedProject = _objectSpread(_objectSpread({}, project), {}, _defineProperty({}, key, value));
      }
      this.updateProjectAndValidate(updatedProject);
    }
  }, {
    key: "handleListChange",
    value: function handleListChange(event, inputName) {
      var project = this.state.project;
      var original = String(event.target.value);
      var value = sanitizeOnChangeValue(original);
      var newLength = value.length;
      var characterCode = value.substr(1).charCodeAt(0);
      if (newLength > 0) {
        if (characterCode === 10) {
          value = "<l>".concat(value, "</l>");
        } else if (newLength === 1) {
          value = "<li>".concat(value, "</li>");
        }
      }
      this.updateProjectAndValidate(_objectSpread(_objectSpread({}, project), {}, _defineProperty({}, inputName, value)));
    }
  }, {
    key: "handleNestedAttributeChange",
    value: function handleNestedAttributeChange(values, key) {
      var project = this.state.project;
      var processed = values.map(function (value) {
        return {
          description: value
        };
      });
      processed = processed.filter(function (v) {
        return v.description !== '';
      });
      var updatedProject = _objectSpread(_objectSpread({}, project), {}, _defineProperty({}, key, processed));
      this.updateProjectAndValidate(updatedProject);
    }
  }, {
    key: "doesPageHaveErrors",
    value: function doesPageHaveErrors(page) {
      var errorMessages = this.state.errorMessages;
      var possibleErrorsOnPage;
      switch (page) {
        case 1:
          possibleErrorsOnPage = ['Project name', 'Description', 'Responsibilities', 'Ideal candidate'];
          break;
        case 2:
          possibleErrorsOnPage = ['Office location', 'Work Location'];
          break;
        case 3:
          possibleErrorsOnPage = ['Length of engagement', 'Average hours', 'Min hourly rate', 'Max hourly rate'];
          break;
        default:
          possibleErrorsOnPage = [];
      }

      // returns true if some of the possible errors
      // on this page are in the current error messages state variable
      return possibleErrorsOnPage.some(function (possibleError) {
        return errorMessages.includes(possibleError);
      });
    }
  }, {
    key: "updateProjectAndValidate",
    value: function updateProjectAndValidate(newProject) {
      var errorMessages = getErrorMessages(newProject);
      this.setState({
        errorMessages: errorMessages,
        project: newProject
      });
    }
  }, {
    key: "afterCreateOpenMarketplaceInvite",
    value: function afterCreateOpenMarketplaceInvite(data) {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        consultant = _this$props.consultant,
        handleInvited = _this$props.handleInvited,
        query = _this$props.query;
      var _this$state = this.state,
        project = _this$state.project,
        customMessage = _this$state.customMessage;
      var projectResourceId = data.resource_id;
      var updatedProject = _objectSpread(_objectSpread({}, project), {}, {
        resource_id: projectResourceId
      });
      this.setState({
        project: updatedProject
      });
      postRequest("/projects/".concat(projectResourceId, "/project_invitations"), {
        consultant_resource_id: consultant.resource_id,
        query_id: query,
        custom_message: customMessage,
        request_proposal: true
      }, csrfToken).then(function () {
        analyticsTrack('Clicked Send on Create New Project modal', {
          location: 'Consultant Profile Page'
        });
        handleInvited(projectResourceId);
      });
    }
  }, {
    key: "afterCreateProjectRequest",
    value: function afterCreateProjectRequest(data) {
      var handleInvited = this.props.handleInvited;
      var project = this.state.project;
      var projectResourceId = data.resource_id;
      var updatedProject = _objectSpread(_objectSpread({}, project), {}, {
        resource_id: projectResourceId
      });
      this.setState({
        project: updatedProject
      });
      analyticsTrack('Clicked Send on Create New Project modal', {
        location: 'Hire Again Page'
      });
      handleInvited(projectResourceId);
    }
  }, {
    key: "handleSaveProjectAndInvite",
    value: function handleSaveProjectAndInvite() {
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        consultant = _this$props2.consultant,
        isRep = _this$props2.isRep,
        companyId = _this$props2.companyId,
        query = _this$props2.query,
        hireAgain = _this$props2.hireAgain;
      var _this$state2 = this.state,
        project = _this$state2.project,
        localExpertiseTags = _this$state2.localExpertiseTags,
        localNotApplicable = _this$state2.localNotApplicable,
        localPriorityExpertiseTags = _this$state2.localPriorityExpertiseTags,
        localNonPriorityExpertiseTags = _this$state2.localNonPriorityExpertiseTags;
      var params = {
        project: _objectSpread(_objectSpread({}, project), {}, {
          responsibility_areas_attributes: sanitizeResponsibilityHtml(project.responsibility_areas_attributes)
        })
      };

      // If we haven't created a project yet, include qualifications and must-haves from local state
      if (!project.resource_id) {
        var models = ['area_of_expertise', 'therapeutic_area', 'disease_code', 'therapy', 'regulatory_pathway', 'development_phase', 'degree', 'language', 'skill', 'accreditation'];
        if (localExpertiseTags) {
          Object.assign(params.project, localExpertiseTags);
          models.forEach(function (model) {
            var notApp = Array.isArray(localNotApplicable) && localNotApplicable.includes(model);
            if (model === 'therapy') {
              params.project.therapies_not_applicable = notApp;
            } else {
              params.project["".concat(model, "s_not_applicable")] = notApp;
            }
          });
        }
        if (localPriorityExpertiseTags || localNonPriorityExpertiseTags) {
          models.forEach(function (model) {
            if (localPriorityExpertiseTags && localPriorityExpertiseTags["".concat(model, "_ids")]) {
              params.project["priority_".concat(model, "_ids")] = localPriorityExpertiseTags["".concat(model, "_ids")];
            }
            if (localNonPriorityExpertiseTags && localNonPriorityExpertiseTags["".concat(model, "_ids")]) {
              params.project["non_priority_".concat(model, "_ids")] = localNonPriorityExpertiseTags["".concat(model, "_ids")];
            }
          });
        }
      }
      if (hireAgain) {
        params.project.rehire_user_resource_id = consultant.resource_id;
        if (isRep) {
          params.project.company_id = companyId;
        }
      } else {
        params.project.ssp = true;
        params.query_id = query;
      }
      var callback = hireAgain ? this.afterCreateProjectRequest : this.afterCreateOpenMarketplaceInvite;
      postRequest('/projects', params, csrfToken).then(function (_ref4) {
        var data = _ref4.data;
        callback(data);
      });
    }
  }, {
    key: "handleUpdateCustomMessage",
    value: function handleUpdateCustomMessage(customMessage) {
      this.setState({
        customMessage: customMessage
      });
    }
  }, {
    key: "renderPageNav",
    value: function renderPageNav() {
      var _this2 = this;
      var currentPage = this.state.currentPage;
      return /*#__PURE__*/React.createElement("div", {
        className: "question-tabs"
      }, /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.setPage(1);
        },
        className: "tab ".concat(currentPage === 1 ? 'active' : '', " ").concat(currentPage === 2 || currentPage === 3 ? 'done' : '', "\n          ").concat(this.doesPageHaveErrors(1) ? 'incomplete' : 'complete')
      }, /*#__PURE__*/React.createElement("div", {
        className: "bar"
      }), boldIf('About', currentPage === 1)), /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.setPage(2);
        },
        className: "tab ".concat(currentPage === 2 ? 'active' : '', " ").concat(currentPage === 3 ? 'done' : '', "\n          ").concat(this.doesPageHaveErrors(2) ? 'incomplete' : 'complete')
      }, /*#__PURE__*/React.createElement("div", {
        className: "bar"
      }), boldIf('Location', currentPage === 2)), /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.setPage(3);
        },
        className: "tab ".concat(currentPage === 3 ? 'active' : '', "\n          ").concat(this.doesPageHaveErrors(3) ? 'incomplete' : 'complete')
      }, /*#__PURE__*/React.createElement("div", {
        className: "bar"
      }), boldIf('Availability', currentPage === 3)));
    }
  }, {
    key: "renderTravelQuestion",
    value: function renderTravelQuestion() {
      var _this3 = this;
      var project = this.state.project;
      return /*#__PURE__*/React.createElement("div", {
        className: "logistics"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, /*#__PURE__*/React.createElement("h4", null, "Travel Requirements")), /*#__PURE__*/React.createElement("div", {
        className: "travel-location"
      }, /*#__PURE__*/React.createElement("input", {
        className: "travel-location-input",
        type: "text",
        id: "travel-location-input",
        name: "travel-location-input",
        value: project.project_travel_locations_attributes ? project.project_travel_locations_attributes[0].description : '',
        onChange: function onChange(e) {
          return _this3.handleChange(e.target.value, 'travel_location');
        },
        placeholder: "Ex: 40% travel to clinical sites in the East Coast"
      })));
    }
  }, {
    key: "renderWorkplaceChoice",
    value: function renderWorkplaceChoice() {
      var _this4 = this;
      var workLocationOptions = this.props.workLocationOptions;
      var project = this.state.project;
      var options = Object.entries(workLocationOptions).map(function (location) {
        return {
          value: location[0],
          title: location[1]
        };
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "workplace-type-container"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "work-location"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "regular-spacing"
      }, "Workplace Type", /*#__PURE__*/React.createElement("span", {
        className: "required-text-gray"
      }, "* Required"))), /*#__PURE__*/React.createElement(FilterTag, {
        options: options,
        handleChange: function handleChange(option) {
          return _this4.handleChange(option, 'work_location');
        },
        selected: project.work_location
      }));
    }
  }, {
    key: "renderQuestions",
    value: function renderQuestions() {
      var _this5 = this;
      var _this$state3 = this.state,
        currentPage = _this$state3.currentPage,
        project = _this$state3.project,
        errorMessages = _this$state3.errorMessages,
        suggestionShow = _this$state3.suggestionShow,
        suggestedTags = _this$state3.suggestedTags;
      var csrfToken = this.props.csrfToken;
      if (currentPage === 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: "questions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-group question name"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "name",
          className: "required"
        }, /*#__PURE__*/React.createElement("h4", {
          className: "regular-spacing"
        }, "Project Title:")), /*#__PURE__*/React.createElement("input", {
          type: "text",
          id: "name",
          className: "form-control",
          name: "name",
          placeholder: "e.g. Clinical Project Manager for Phase I Oncology Study",
          value: project.name,
          onChange: function onChange(e) {
            return _this5.handleChange(e.target.value, 'name');
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-group question description"
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-8"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "description",
          className: "required"
        }, /*#__PURE__*/React.createElement("h4", {
          className: "regular-spacing"
        }, "About the project:")), /*#__PURE__*/React.createElement("p", {
          className: "explanation secondary-body-text"
        }, "Consultants tell us this is one of the first things they look at in a project. Details here will generate more positive interest in your project.")), /*#__PURE__*/React.createElement(TextareaAutosize, {
          className: "form-control form-control--light",
          name: "description",
          id: "description",
          rows: 3,
          placeholder: "e.g. We are a clinical-stage company looking for a Clinical Project Manager consultant to lead our Phase I study. This consultant will provide CRO and vendor management support, including document management and planning, for an ongoing Phase I Solid Tumor trial.",
          onChange: function onChange(e) {
            return _this5.handleChange(e.target.value, 'description');
          },
          value: project.description
        }), suggestionShow && /*#__PURE__*/React.createElement("div", {
          className: "clear-suggestion-container"
        }, /*#__PURE__*/React.createElement("span", {
          className: "suggestion-text"
        }, 'We\'ve added copy suggestions'), /*#__PURE__*/React.createElement("a", {
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return _this5.handleChange('', 'description');
          }
        }, "Clear Suggestions"))), /*#__PURE__*/React.createElement("div", {
          className: "form-group question responsibility_areas_attributes"
        }, /*#__PURE__*/React.createElement(ContentEditableComponent, {
          title: "Main responsibilities:",
          description: "Example: Manage and direct all clinical processes and\n                operations relating to clinical data management for clinical trials.",
          className: "responsibilities",
          handleOnChange: function handleOnChange(event) {
            return _this5.handleListChange(event, 'responsibility_areas_attributes');
          },
          handleClearSuggestions: function handleClearSuggestions() {
            return _this5.handleResponsibilitiesChange('');
          },
          value: project.responsibility_areas_attributes,
          errorMessage: errorMessages.includes('Responsibilities') ? 'should be more than 100 characters' : null,
          showError: true,
          withBulletPoints: true,
          required: true,
          rehireOrProposalRequest: true
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-group question ideal_candidate_description"
        }, /*#__PURE__*/React.createElement(ContentEditableComponent, {
          title: "Ideal candidate:",
          description: "Example: 5+ years in clinical project management; oncology experience; strong CRO/vendor management; PMP a plus.",
          className: "ideal-candidate",
          handleOnChange: function handleOnChange(event) {
            return _this5.handleListChange(event, 'ideal_candidate_description');
          },
          value: project.ideal_candidate_description,
          errorMessage: errorMessages.includes('Ideal candidate') ? 'should be more than 100 characters' : null,
          showError: true,
          withBulletPoints: true,
          required: true,
          rehireOrProposalRequest: true
        })));
      }
      if (currentPage === 2) {
        return /*#__PURE__*/React.createElement("div", {
          className: "questions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-group question work-location"
        }, this.renderWorkplaceChoice(), project.work_location && project.work_location === 'remote' && this.renderRemoteLocationInput(), project.work_location && ['hybrid', 'office'].includes(project.work_location) && this.renderOfficeLocationInput(), this.renderTravelQuestion()));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "questions availability"
      }, this.renderProjectLengthQuestion(), this.renderProjectHoursQuestion(), this.renderHourlyRate());
    }
  }, {
    key: "renderReview",
    value: function renderReview() {
      var _this6 = this;
      var _this$state4 = this.state,
        project = _this$state4.project,
        errorMessages = _this$state4.errorMessages,
        customMessage = _this$state4.customMessage,
        suggestedOpen = _this$state4.suggestedOpen,
        suggestedLoading = _this$state4.suggestedLoading,
        suggestedHeadline = _this$state4.suggestedHeadline,
        suggestedTags = _this$state4.suggestedTags,
        vocabulary = _this$state4.vocabulary;
      var _this$props3 = this.props,
        consultant = _this$props3.consultant,
        csrfToken = _this$props3.csrfToken;
      var durationUnit = project.duration_unit || 'months';
      var durationText = project.duration_range ? "".concat(project.duration_range, " ").concat(durationUnit.replace(/s$/, '')).concat(Number(project.duration_range) === 1 ? '' : 's') : null;
      var workCommitmentText = project.avg_time_required_range ? "".concat(project.avg_time_required_range, " hours per ").concat(project.avg_time_required_unit || 'week') : null;
      return /*#__PURE__*/React.createElement("div", {
        className: "review-and-invite p-5"
      }, this.renderHeader('review'), /*#__PURE__*/React.createElement(ProjectSummary, {
        name: project.name,
        description: project.description || 'Project description goes here...',
        duration: project.duration_range,
        durationText: durationText,
        workLocation: project.work_location,
        daysOfTravel: project.days_of_travel,
        travelTime: project.travel_time,
        workCommitment: project.avg_time_required_range,
        workCommitmentText: workCommitmentText,
        startDate: project.approximate_start_date_local,
        minHourlyRate: project.budget_minimum != null ? String(project.budget_minimum) : '',
        maxHourlyRate: project.budget_maximum != null ? String(project.budget_maximum) : '',
        responsibilities: listElementsToArray(project.responsibility_areas_attributes),
        ideal_candidate_list: listElementsToArray(project.ideal_candidate_description),
        shortOfficeLocation: project.office_location || '',
        travelLocations: project.project_travel_locations_attributes && project.project_travel_locations_attributes.map(function (r) {
          return r.description;
        }),
        tags: this.state.reviewTags,
        areaOfExpertises: [],
        location: "SearchProjectCreation"
      }), /*#__PURE__*/React.createElement(ProjectInvitationCustomTextbox, {
        consultantFirstName: firstName(consultant),
        updateParentMessage: this.handleUpdateCustomMessage,
        customMessage: customMessage
      }), errorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "error-message"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), "Required:", ' ', errorMessages.join(', ')), /*#__PURE__*/React.createElement("div", {
        className: "actions mt-3"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary standard-button half-spacing back-btn",
        onClick: function onClick() {
          analyticsTrack('Clicked Edit on Create New Project modal', {
            location: 'Consultant Profile Page'
          });
          _this6.setPage(1);
        }
      }, "Edit"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary standard-button half-spacing review-and-send",
        onClick: function onClick() {
          return _this6.handleSaveProjectAndInvite();
        },
        disabled: errorMessages.length > 0
      }, "Send Project")));
    }

    // --- Suggested Tags helpers ---
  }, {
    key: "mapSuggestedTagsToModels",
    value: function mapSuggestedTagsToModels(tags) {
      if (!tags) return {};
      var map = {
        'Functional Area': 'area_of_expertise',
        'Therapeutic Areas': 'therapeutic_area',
        'Product Technologies': 'therapy',
        'Product Tech': 'therapy',
        'Diseases/Indications': 'disease_code',
        'Phases of Development': 'development_phase',
        'Regulatory Pathway': 'regulatory_pathway'
      };
      var out = {};
      Object.keys(tags).forEach(function (cat) {
        var m = map[cat];
        if (!m) return;
        out[m] = (tags[cat] || []).filter(Boolean);
      });
      return out;
    }
  }, {
    key: "refreshReviewTags",
    value: function () {
      var _refreshReviewTags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var project, resp, data, merged;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              project = this.state.project;
              if (!(!project || !project.resource_id)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.next = 5;
              return getRequest("/projects/".concat(project.resource_id, "?form_step=review"));
            case 5:
              resp = _context2.sent;
              data = resp && resp.data ? resp.data : {};
              merged = Array.from(new Set([].concat(_toConsumableArray(data.priority_expertise_tags || []), _toConsumableArray(data.non_priority_expertise_tags || []))));
              this.setState({
                reviewTags: merged
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function refreshReviewTags() {
        return _refreshReviewTags.apply(this, arguments);
      }
      return refreshReviewTags;
    }()
  }, {
    key: "suggestCategoryKey",
    value: function suggestCategoryKey(category) {
      var map = {
        'Functional Area': 'area_of_expertise_names',
        'Therapeutic Areas': 'therapeutic_area_names',
        'Product Technologies': 'therapy_names',
        'Product Tech': 'therapy_names',
        'Diseases/Indications': 'disease_code_names',
        'Phases of Development': 'development_phase_names',
        'Regulatory Pathway': null
      };
      return map[category] || null;
    }
  }, {
    key: "toggleSuggestedOpen",
    value: function toggleSuggestedOpen() {
      var _this7 = this;
      var suggestedTags = this.state.suggestedTags;
      this.setState(function (prev) {
        return {
          suggestedOpen: !prev.suggestedOpen
        };
      }, function () {
        if (Object.keys(suggestedTags || {}).length === 0 && _this7.state.suggestedOpen) {
          _this7.fetchSuggestedTags();
        }
      });
    }
  }, {
    key: "fetchSuggestedTags",
    value: function fetchSuggestedTags() {
      var _this8 = this;
      var csrfToken = this.props.csrfToken;
      var project = this.state.project;
      var payload = {
        title: project.name,
        description: project.description,
        ideal_candidate_description: project.ideal_candidate_description,
        responsibilities: listElementsToArray(project.responsibility_areas_attributes)
      };
      this.setState({
        suggestedLoading: true
      });
      postRequest('/projects/suggest_tags', payload, csrfToken).then(function (_ref5) {
        var data = _ref5.data;
        var headline = data.headline || null;
        var tags = data.tags || {};
        var vocabulary = data.vocabulary || {};
        _this8.setState({
          suggestedHeadline: headline,
          suggestedTags: tags,
          vocabulary: vocabulary,
          suggestedLoading: false
        });
      })["catch"](function () {
        _this8.setState({
          suggestedLoading: false
        });
      });
    }
  }, {
    key: "toggleTagSelection",
    value: function toggleTagSelection(category, value) {
      var key = this.suggestCategoryKey(category);
      if (!key) return;
      var project = this.state.project;
      var current = Array.isArray(project[key]) ? project[key] : [];
      var exists = current.includes(value);
      var next = exists ? current.filter(function (v) {
        return v !== value;
      }) : [].concat(_toConsumableArray(current), [value]);
      this.setState({
        project: _objectSpread(_objectSpread({}, project), {}, _defineProperty({}, key, next))
      });
    }
  }, {
    key: "addTagFromDropdown",
    value: function addTagFromDropdown(category, event) {
      var value = event.target.value;
      if (!value) return;
      this.toggleTagSelection(category, value);
      // reset select
      event.target.selectedIndex = 0;
    }
  }, {
    key: "renderSuggestedTagsUI",
    value: function renderSuggestedTagsUI(suggestedTags, vocabulary) {
      var _this9 = this;
      var categories = ['Functional Area', 'Therapeutic Areas', 'Product Technologies', 'Product Tech', 'Diseases/Indications', 'Phases of Development'];
      var project = this.state.project;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, categories.map(function (cat) {
        var key = _this9.suggestCategoryKey(cat);
        if (!key) return null;
        var selected = Array.isArray(project[key]) ? project[key] : [];
        var suggestions = Array.isArray(suggestedTags[cat]) ? suggestedTags[cat] : [];
        var options = Array.isArray(vocabulary[cat]) ? vocabulary[cat] : [];
        var uniqueSuggestions = _toConsumableArray(new Set(suggestions));
        return /*#__PURE__*/React.createElement("div", {
          className: "mb-2",
          key: cat
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-1"
        }, /*#__PURE__*/React.createElement("strong", null, cat)), /*#__PURE__*/React.createElement("div", {
          className: "d-flex flex-wrap gap-2"
        }, uniqueSuggestions.map(function (tag) {
          return /*#__PURE__*/React.createElement("button", {
            type: "button",
            key: tag,
            className: "badge small ".concat(selected.includes(tag) ? 'purple-base' : ''),
            onClick: function onClick() {
              return _this9.toggleTagSelection(cat, tag);
            },
            title: selected.includes(tag) ? 'Remove' : 'Add'
          }, tag);
        })), /*#__PURE__*/React.createElement("div", {
          className: "mt-1"
        }, /*#__PURE__*/React.createElement("label", {
          className: "me-2 body-text-3 muted-gray-text"
        }, "Add more:"), /*#__PURE__*/React.createElement("select", {
          onChange: function onChange(e) {
            return _this9.addTagFromDropdown(cat, e);
          }
        }, /*#__PURE__*/React.createElement("option", {
          value: ""
        }, "Select\u2026"), options.filter(function (o) {
          return !selected.includes(o);
        }).map(function (o) {
          return /*#__PURE__*/React.createElement("option", {
            key: o,
            value: o
          }, o);
        }))));
      }));
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this10 = this;
      var currentPage = this.state.currentPage;
      var backToProjectSelection = this.props.backToProjectSelection;
      var pageHasErrors = this.doesPageHaveErrors(currentPage);
      if (currentPage <= 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: "actions"
        }, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-secondary standard-button half-spacing back-btn",
          onClick: function onClick() {
            return backToProjectSelection();
          }
        }, "Back"), /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary standard-button half-spacing next-btn",
          onClick: this.handleNextFromPage1,
          disabled: pageHasErrors
        }, "Next"));
      }
      if (currentPage === 2) {
        return /*#__PURE__*/React.createElement("div", {
          className: "actions"
        }, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-secondary standard-button half-spacing back-btn",
          onClick: function onClick() {
            return _this10.setPage(1);
          }
        }, "Back"), /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary standard-button half-spacing next-btn",
          onClick: function onClick() {
            return _this10.setPage(3);
          },
          disabled: pageHasErrors
        }, "Next"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary standard-button half-spacing back-btn",
        onClick: function onClick() {
          return _this10.setPage(2);
        }
      }, "Back"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary standard-button half-spacing next-btn",
        onClick: function onClick() {
          return _this10.setPage(4);
        },
        disabled: pageHasErrors
      }, "Review & Send"));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(context) {
      var _this$props4 = this.props,
        hireAgain = _this$props4.hireAgain,
        consultant = _this$props4.consultant;
      if (hireAgain) {
        var hireAgainHeaderCopy = context === 'review' ? "Review project information. ".concat(firstName(consultant), " will read it.") : "".concat(consultant.name, " will read this project information.");
        var subtitle = "Clora will share this information with ".concat(firstName(consultant), " and \n      check their availability.");
        return /*#__PURE__*/React.createElement("div", {
          className: "pt-60 mb-4"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "mb-12"
        }, hireAgainHeaderCopy), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 normal-weight"
        }, subtitle));
      }
      return null;
    }
  }, {
    key: "renderOfficeLocationInput",
    value: function renderOfficeLocationInput() {
      var _this11 = this;
      var project = this.state.project;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, /*#__PURE__*/React.createElement("h4", null, "Days in the Office", /*#__PURE__*/React.createElement("span", {
        className: "required-text-gray"
      }, "* Required"))), /*#__PURE__*/React.createElement("div", {
        className: "office-days-container"
      }, /*#__PURE__*/React.createElement("input", {
        className: "office-days-input",
        placeholder: "5",
        type: "number",
        id: "office-days",
        name: "office-days",
        onChange: function onChange(e) {
          return _this11.handleChange(e.target.value, 'days_in_office');
        },
        value: project.days_in_office
      }), /*#__PURE__*/React.createElement("span", {
        className: "office-days-text"
      }, "days per week in the office."))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, /*#__PURE__*/React.createElement("h4", null, "Office Location", /*#__PURE__*/React.createElement("span", {
        className: "required-text-gray"
      }, "* Required"))), /*#__PURE__*/React.createElement("div", {
        className: "location-input"
      }, /*#__PURE__*/React.createElement(LocationAutocomplete, {
        inputId: "office-location-input",
        value: project.office_location,
        onValueChange: function onValueChange(value) {
          return _this11.handleChange(value, 'office_location');
        },
        defaultSample: "Ex: 123 Boston Way, Boston, MA"
      }), /*#__PURE__*/React.createElement("img", {
        src: SearchIcon,
        className: "search-icon",
        alt: "search-icon"
      }))));
    }
  }, {
    key: "renderRemoteLocationInput",
    value: function renderRemoteLocationInput() {
      var _this12 = this;
      var project = this.state.project;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, /*#__PURE__*/React.createElement("h4", null, "Desired Candidate Location")), /*#__PURE__*/React.createElement("div", {
        className: "remote-preferred-location"
      }, /*#__PURE__*/React.createElement("input", {
        className: "remote-location-input",
        type: "text",
        id: "remote-location-input",
        name: "remote-location-input",
        value: project.remote_preferred_location,
        onChange: function onChange(e) {
          return _this12.handleChange(e.target.value, 'remote_preferred_location');
        },
        placeholder: "Ex: Bay area, CA; Conn, NJ, or NY"
      })));
    }
  }, {
    key: "renderHourlyRate",
    value: function renderHourlyRate() {
      var _this13 = this;
      var project = this.state.project;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 normal-weight mb-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logistics-header"
      }, /*#__PURE__*/React.createElement("h4", null, "Preferred Hourly Rate", /*#__PURE__*/React.createElement("span", {
        className: "required-text"
      }, "* Required"))), /*#__PURE__*/React.createElement("div", {
        className: "budget-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "budget-input-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "dollar-icon"
      }, "$"), /*#__PURE__*/React.createElement("input", {
        name: "budget-minimum",
        id: "budget-minimum",
        className: "form-control rate-form budget-input",
        placeholder: "Minimum",
        required: "required",
        value: project.budget_minimum ? project.budget_minimum : '',
        onChange: function onChange(e) {
          return _this13.handleChange(Number(e.target.value), 'budget_minimum');
        }
      })), /*#__PURE__*/React.createElement("span", {
        className: "mx-3 range-span"
      }, "-"), /*#__PURE__*/React.createElement("div", {
        className: "budget-input-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "dollar-icon"
      }, "$"), /*#__PURE__*/React.createElement("input", {
        name: "budget-maximum",
        id: "budget-maximum",
        className: "form-control rate-form budget-input",
        placeholder: "Maximum",
        required: "required",
        value: project.budget_maximum ? project.budget_maximum : '',
        onChange: function onChange(e) {
          return _this13.handleChange(Number(e.target.value), 'budget_maximum');
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "rate-question"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "rate-negotiable-checkbox",
        className: "custom-checkbox-container"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "rate-negotiable-checkbox",
        name: "rate-negotiable-checkbox",
        className: "checkbox-box",
        checked: project.rate_negotiable,
        onChange: function onChange(e) {
          return _this13.handleChange(e.target.checked, 'rate_negotiable');
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text ".concat(project.rate_negotiable ? 'active' : '')
      }, "Rate is negotiable"))));
    }
  }, {
    key: "renderProjectLengthQuestion",
    value: function renderProjectLengthQuestion() {
      var _this14 = this;
      var project = this.state.project;
      var selectedDurationUnit = project.duration_unit || 'months';
      var maxDuration = selectedDurationUnit === 'weeks' ? 104 : 24;
      var durationLabel = selectedDurationUnit === 'weeks' ? 'weeks' : 'months';
      return /*#__PURE__*/React.createElement("div", {
        className: "project-length-question"
      }, /*#__PURE__*/React.createElement("h4", null, "What is the expected length of the engagement?", /*#__PURE__*/React.createElement("span", {
        className: "heading-required"
      }, "* Required")), /*#__PURE__*/React.createElement("div", {
        className: "project-length-container"
      }, /*#__PURE__*/React.createElement("input", {
        placeholder: "",
        type: "number",
        id: "project-length",
        name: "project-length",
        value: project.duration_range ? project.duration_range : '',
        onKeyDown: numericKeyFilter,
        onChange: function onChange(e) {
          return _this14.handleChange(e.target.value, 'duration_range');
        }
      }), /*#__PURE__*/React.createElement("select", {
        className: "project-time-unit-select ms-2",
        "aria-label": "Length of engagement unit",
        value: selectedDurationUnit,
        onChange: function onChange(e) {
          return _this14.handleChange(e.target.value, 'duration_unit');
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "months"
      }, "months"), /*#__PURE__*/React.createElement("option", {
        value: "weeks"
      }, "weeks"))), project.duration_range && project.duration_range > maxDuration && /*#__PURE__*/React.createElement("div", {
        className: "error-text"
      }, "Cannot be more than ".concat(maxDuration, " ").concat(durationLabel, ".")));
    }
  }, {
    key: "renderProjectHoursQuestion",
    value: function renderProjectHoursQuestion() {
      var _this15 = this;
      var project = this.state.project;
      var selectedAvgHoursUnit = project.avg_time_required_unit || 'week';
      return /*#__PURE__*/React.createElement("div", {
        className: "project-hours-question"
      }, /*#__PURE__*/React.createElement("h4", null, "How many hours on average will the consultant work?", /*#__PURE__*/React.createElement("span", {
        className: "heading-required"
      }, "* Required")), /*#__PURE__*/React.createElement("div", {
        className: "project-hours-container mt-2"
      }, /*#__PURE__*/React.createElement("input", {
        placeholder: "",
        type: "number",
        name: "project-hours",
        id: "project-hours",
        min: "1",
        value: project.avg_time_required_range ? project.avg_time_required_range : '',
        onKeyDown: numericKeyFilter,
        onChange: function onChange(e) {
          return _this15.handleChange(e.target.value, 'avg_time_required_range');
        }
      }), /*#__PURE__*/React.createElement("select", {
        className: "project-time-unit-select ms-2",
        "aria-label": "Average hours unit",
        value: selectedAvgHoursUnit,
        onChange: function onChange(e) {
          return _this15.handleChange(e.target.value, 'avg_time_required_unit');
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "week"
      }, "hours per week"), /*#__PURE__*/React.createElement("option", {
        value: "month"
      }, "hours per month"))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        consultant = _this$props5.consultant,
        hireAgain = _this$props5.hireAgain;
      var currentPage = this.state.currentPage;
      return /*#__PURE__*/React.createElement("div", {
        className: "search-project-creation"
      }, !hireAgain && /*#__PURE__*/React.createElement("div", {
        className: "consultant-detail"
      }, /*#__PURE__*/React.createElement("div", {
        className: "init-icon"
      }, /*#__PURE__*/React.createElement("span", {
        className: "icon-initials"
      }, consultant.initials)), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight invite-heading"
      }, "Tell ".concat(consultant.first_name, " about your project and who you\u2019re looking for."))), currentPage < 4 ? /*#__PURE__*/React.createElement("div", {
        className: "questions-container"
      }, this.renderHeader('intro'), this.renderPageNav(), this.renderQuestions(), this.renderActions()) : /*#__PURE__*/React.createElement(Fragment, null, this.renderReview()));
    }
  }]);
}(Component);
SearchProjectCreation.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  project: PropTypes.shape({}),
  backToProjectSelection: PropTypes.func.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  handleInvited: PropTypes.func.isRequired,
  query: PropTypes.number,
  hireAgain: PropTypes.bool,
  companyId: PropTypes.number,
  isRep: PropTypes.bool,
  filters: PropTypes.shape({
    higher_level_roles: PropTypes.arrayOf(PropTypes.string),
    area_of_expertises: PropTypes.arrayOf(PropTypes.string),
    therapeutic_areas: PropTypes.arrayOf(PropTypes.string),
    diseases: PropTypes.arrayOf(PropTypes.string),
    therapies: PropTypes.arrayOf(PropTypes.string),
    development_phases: PropTypes.arrayOf(PropTypes.string),
    degrees: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
    levels: PropTypes.arrayOf(PropTypes.string)
  })
};
SearchProjectCreation.defaultProps = {
  project: null,
  query: null,
  hireAgain: false,
  companyId: 0,
  filters: {}
};
export default SearchProjectCreation;